// @flow
import { useCallback } from 'react';

import FilterSection from '@components/catalogFilters/FilterSection';
import FilterTab from '@components/catalogFilters/FilterTab';
import FilterRadioItem from '@components/catalogFilters/FilterRadioItem';
import FilterItems from '@components/catalogFilters/FilterRadioItems';

import PriceRange from '../sliders/ringOrBandSearch/PriceRange';

import ErrorBoundary from '../ErrorBoundary';

import css from '@styles/ringFilters';

function PriceFilters({
  priceValues,
  priceExtents,
  sortDirection,
  onPriceFilterChange,
  onRadioFilterChange,
  isOpen,
  onToggle
}) {
  const handleRadioToggle = useCallback(e => {
    onRadioFilterChange('sort', e.currentTarget.value);
  }, []);

  // At a minimum, we must have extents
  const validPriceRangeExists = priceExtents && priceExtents.length === 2;

  // We have to ensure that the slider shows at least the min or max filter that
  // the user has selected, if they have selected any price filters.
  if (priceValues) {
    if (priceExtents[0] > priceValues[1]) { priceExtents[0] = priceValues[1] }
    if (priceExtents[1] < priceValues[0]) { priceExtents[1] = priceValues[0] }
  }

  return (
    <FilterSection
      className={css.priceRange}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}
    >
      <FilterTab
        name='Price Range'
        className={css.priceRangeTab}
        showingContent={isOpen}
        activeFilterCount={priceValues ? 1 : 0}
        onClick={onToggle}
        key='price-tab'
      />
      <FilterItems
        className={css.priceRangeContent}
        show={isOpen}
        ElementType='div'
        key='price-content'
      >
        <ErrorBoundary
          fallback={false}
          resetOnChanges={{
            value: priceValues,
            extent: priceExtents
          }}
        >
          <PriceRange
            value={priceValues}
            extent={priceExtents}
            onSliderUpdate={onPriceFilterChange}
          />
        </ErrorBoundary>

        <ul>
          <FilterRadioItem
            label='High to Low'
            inputValue='desc'
            htmlId='sort-desc'
            htmlName='price_sort_direction'
            selected={sortDirection === 'desc'}
            onChange={handleRadioToggle}
          />
          <FilterRadioItem
            label='Low to High'
            inputValue='asc'
            htmlId='sort-asc'
            htmlName='price_sort_direction'
            selected={sortDirection === 'asc'}
            onChange={handleRadioToggle}
          />
        </ul>
      </FilterItems>
    </FilterSection>
  );
}

export default PriceFilters;
